import React, { FC, useEffect } from 'react';
import {
  GraphWindow,
  useSidebarData,
  useSidebarWindow,
} from '@graph-sidebar-module/shared';
import {
  CopyHash,
  Divider,
  DriverHeader,
  Spacer,
  Toggle,
  ToggleItem,
  Typography,
} from '@rubin-dev/goblin';
import { TokenSelect } from '@graph-sidebar-module/features/Token';
import { openAddress } from '@shared/libs';
import { useTranslation } from 'react-i18next';
import {
  AddressInfo,
  AddressTransactionsTable,
} from '@graph-sidebar-module/entities/Address';

import cls from './styles.module.scss';
import { useCurrencyListStore } from '@graph/libs';
import { TabAssetCurrency } from '@graph/libs/store';
import { NetworkIconEnum } from '@shared/ui';
import { getNetworkEnum } from '@helpers/address';
import { Network } from '@apolloGenerated';

export const AddressWindow: FC = () => {
  const { t } = useTranslation();
  const { hash, network, isLoading } = useSidebarData();
  const [{ onHide }, { isShow }] = useSidebarWindow();

  const { isAsset, currentCurrency, changeCurrencyCurrent, changeIsAsset } =
    useCurrencyListStore();

  useEffect(() => {
    if (network && getNetworkEnum(network) === Network.Btc) {
      changeCurrencyCurrent(NetworkIconEnum.Btc);
    }
  }, [network]);

  const listButtons: ToggleItem<TabAssetCurrency>[] = [
    { value: TabAssetCurrency.Asset, label: t('titles.asset') },
    { value: TabAssetCurrency.usd, label: t('titles.usd') },
  ];

  const onChangeToggle = (val: TabAssetCurrency) => {
    changeIsAsset(val);
  };

  return (
    <GraphWindow
      isOpen={isShow}
      onClose={onHide}
      width={763}
      isLoading={isLoading}
      headerSlot={
        <div className={cls.container}>
          <DriverHeader
            titleSlot={
              <CopyHash
                hash={hash}
                variant="head-24"
                className={cls.copyHash}
                onClickHash={() => openAddress(network, hash)}
              />
            }
          />
          <div className={cls.wrapper}>
            <TokenSelect
              size="small"
              onChange={changeCurrencyCurrent}
              currentNetwork={currentCurrency}
              network={network}
            />
            <Toggle
              initValue={isAsset}
              items={listButtons}
              onChange={onChangeToggle}
              size="small"
            />
          </div>
        </div>
      }
    >
      <AddressInfo address={hash} network={network} />
      <Spacer size={20} />
      <Typography variant="head-20" color="on-surface-primary-1">
        {t('strings.transactions')}
      </Typography>
      <Spacer size={8} />
      <Divider />
      <Spacer size={12} />
      <AddressTransactionsTable currentCurrency={currentCurrency} />
    </GraphWindow>
  );
};
